import React from 'react'
import { Box, Flex, Text } from '@workwhile/ui'
import { Link } from 'react-router-dom'
import { ClipboardList, RadioTower, TriangleAlert } from 'lucide-react'
import * as ROUTES from 'constants/routes'
import { Header } from 'components/Header'
import { AccordionCard } from 'components/AccordionCard'

export const Jet = () => {
  return (
    <>
      <Header title="Jet" />
      <Box margin={3}>
        <Flex gap={3} flexWrap="wrap">
          <Link
            to={ROUTES.JET_CALL_REPORT_SYNC_STATUS}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <RadioTower size={14} />
                  <Text fontSize={2} color="lightText">
                    Call Report Sync Status
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Insight into call reports and sync status or issues.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.JET_ALERTS}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <TriangleAlert size={14} />
                  <Text fontSize={2} color="lightText">
                    Jet Alerts
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                Recurring JET conditions that may need operational attention,
                with their throttle and resolution state.
              </Text>
            </AccordionCard>
          </Link>
          <Link
            to={ROUTES.JET_ASSIGNMENTS}
            style={{
              textDecoration: 'none',
              maxWidth: 'calc(50% - 0.8rem)',
              width: '100%',
            }}
          >
            <AccordionCard
              title={
                <Flex alignItems="center" gap={2} width="100%">
                  <ClipboardList size={14} />
                  <Text fontSize={2} color="lightText">
                    Jet Assignments
                  </Text>
                </Flex>
              }
            >
              <Text fontSize={2}>
                JET assignments with their status, shift and worker mapping, and
                target times.
              </Text>
            </AccordionCard>
          </Link>
        </Flex>
      </Box>
    </>
  )
}
